import { render, staticRenderFns } from "./NetaMultiEventBasicDataComponent.vue?vue&type=template&id=c6289dae&scoped=true&"
import script from "./NetaMultiEventBasicDataComponent.vue?vue&type=script&lang=js&"
export * from "./NetaMultiEventBasicDataComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaMultiEventBasicDataComponent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NetaMultiEventBasicDataComponent.vue?vue&type=style&index=1&id=c6289dae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6289dae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6289dae')) {
      api.createRecord('c6289dae', component.options)
    } else {
      api.reload('c6289dae', component.options)
    }
    module.hot.accept("./NetaMultiEventBasicDataComponent.vue?vue&type=template&id=c6289dae&scoped=true&", function () {
      api.rerender('c6289dae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/neta-multi-event/basic-data/NetaMultiEventBasicDataComponent.vue"
export default component.exports